import React, {useState} from "react"
import {space, VerificationRequest} from "../../compiled";
import {useProfile} from "../../UserProfileProvider";
import {ActionButton} from "../../util/UI/ActionButton";
import {useVerificationRpc} from "../../util/RpcHooks/VerificationRpc";
import ContactMethodType = space.kenko.proto.ContactMethodType;
import {useAuth0} from "@auth0/auth0-react";
import {TextSurveyInput} from "../../components/Inputs/TextSurveyInput";

export const EmailVerification = () => {

  const verificationRpc = useVerificationRpc();
  const {profile} = useProfile();
  const {user} = useAuth0();

  const [verificationCode, setVerificationCode] = useState<string>('');

  const [email, setEmail] = useState<string>();

  // If they're opting to use a different email than their login email.
  const [notUsingLoginEmail, setNotUsingLoginEmail] = useState(false);

  // If they have an email but want to go back to step 1 and change it.
  const [isEditingEmail, setIsEditingEmail] = useState(false);

  // True if an OTP was sent
  const [sentOtp, setSentOtp] = useState(false);


  if (!profile?.contactEmail && user?.email && !notUsingLoginEmail) {
    return <div className={'SurveySection'}>
      Is {user?.email} a good contact email?

      <ActionButton rpcState={verificationRpc.rpcState}
                    onClick={() => verificationRpc.send('set_contact_method', new VerificationRequest({
                      type: ContactMethodType.EMAIL,
                      value: user?.email,
                    }))}>Yes
      </ActionButton>

      <ActionButton secondary onClick={() => setNotUsingLoginEmail(true)}>
        Choose a different email
      </ActionButton>

      {verificationRpc.rpcState.state == 'error' &&
          <div className={'ErrorText'}>{verificationRpc.rpcState.message}</div>}

    </div>
  }

  // Manually enter a different email address 
  if (!profile?.contactEmail || isEditingEmail) {
 
    return <div className={'SurveySection'}>
      <h3>What is a good email for contacting you?</h3>

      <TextSurveyInput inputType={'email'}
                       value={email}
                       onContinue={() => {}}
                       onChange={setEmail}/>

      <ActionButton rpcState={verificationRpc.rpcState}
                    onClick={() => verificationRpc.send('set_contact_method', new VerificationRequest({
                      type: ContactMethodType.EMAIL,
                      value: email,
                    }), () => setIsEditingEmail(false))}>Continue</ActionButton>

      {verificationRpc.rpcState.state == 'error' &&
          <div className={'ErrorText'}>{verificationRpc.rpcState.message}</div>}

    </div>
  }

  if (!sentOtp) {
    return <div className={'SurveySection'}>
      <h3>Please confirm your email address.</h3>
      <div>We'll send a verification code to: {profile?.contactEmail}</div>

      <ActionButton rpcState={verificationRpc.rpcState}
                    onClick={() => verificationRpc.send('send_verification', new VerificationRequest({
                      type: ContactMethodType.EMAIL,
                      value: profile?.contactEmail,
                    }), () => setSentOtp(true))}>Send</ActionButton>

      <ActionButton secondary smaller onClick={() => setIsEditingEmail(true)}>
        Use a different email address
      </ActionButton>

      {verificationRpc.rpcState.state == 'error' &&
          <div className={'ErrorText'}>{verificationRpc.rpcState.message}</div>}

    </div>
  }


  return <div className={'SurveySection'}>
    <h3>Please enter the verification code you received.</h3>

    <TextSurveyInput
        inputType={'text'}
        value={verificationCode}
        onChange={v => setVerificationCode(v ?? '')}
        onContinue={() => {
        }}/>

    <ActionButton rpcState={verificationRpc.rpcState}
                  onClick={() => verificationRpc.send('check_verification_code', new VerificationRequest({
                    type: ContactMethodType.EMAIL,
                    value: verificationCode,
                  }))}>Verify Email</ActionButton>

    <ActionButton secondary smaller onClick={() => setSentOtp(false)}>Go back</ActionButton>

    {verificationRpc.rpcState.state == 'error' && <div className={'ErrorText'}>{verificationRpc.rpcState.message}</div>}
  </div>
}